export const checkNumber = (param) => {
    return isNaN(+param)
}

export const RoundValue = (f) => {
    return !isNaN(f) ? +Math.round(f * 100) / 100 : +0;
}

